import { Button, Col, Form, Input, Row, Table, Upload } from "antd";
import { ColumnsType } from "antd/es/table";
import axios from "axios";
import { get, toNumber } from "lodash";
import { useEffect, useState } from "react";
import cookie from "react-cookies";
import ActionContent from "src/components/common/ActionContent";
import ModalDeleteConfirm from "src/components/common/ModalDeleteConfirm";
import { messages } from "src/constants/messages";
import { apiCaller } from "src/util/apiCaller";
import {
  beforeUploadLimit,
  errUploadFile,
  reDataForTable
} from "src/util/Commom";
import configUrl from "src/util/config";
import { MessageStatusError } from "src/util/MessageStatus";

import {
  CloseCircleOutlined,
  SaveOutlined,
  UploadOutlined
} from "@ant-design/icons";

const FormItem = Form.Item;
const { TextArea } = Input;
const initialState = {
  tacGia: "",
  moTa: ""
};

const HinhAnhDinhKem = ({ idTuLieu }: any) => {
  const [form] = Form.useForm();
  const { tacGia, moTa } = initialState;
  const [listFile, setListFile] = useState([]);
  const [isLoadTable, setIsLoadTable] = useState<boolean>(false);
  const [datatable, setDatatable] = useState([]);
  const [loadingButton, setLoadingButton] = useState(false);
  const [type, setType] = useState("new");
  const [tenFile, setTenFile] = useState("");
  const [duongDanFile, setDuongDanFile] = useState("");
  const [id, setId] = useState(undefined);
  const { validateFields, resetFields, setFieldsValue } = form;
  const [progres, setProgress] = useState(0);

  const columns: ColumnsType<any> = [
    {
      title: "STT",
      dataIndex: "key",
      key: "key",
      width: "5%",
      align: "center"
    },
    { title: "Tên tác giả", dataIndex: "tacGia", key: "tacGia" },
    { title: "Mô tả", dataIndex: "moTa", key: "moTa", width: "25%" },
    {
      title: "File tài liệu",
      dataIndex: "",
      key: "file",
      width: "20%",
      render: (item) => renderFile(item)
    },
    {
      title: "Hành động",
      dataIndex: "",
      key: "x",
      align: "center",
      width: "10%",
      render: (item) => actionContent(item)
    }
  ];

  useEffect(() => {
    getListData(idTuLieu);
  }, []);

  const getListData = async (idTuLieu: any) => {
    setIsLoadTable(true);
    const configAPI = {
      url: `api/tulieufile/${idTuLieu}`,
      method: "GET",
      value: null,
      apiType: "LIST",
      getName: "listTuLieuFile"
    } as any;
    const response = await apiCaller(configAPI);
    try {
      if (
        response?.data &&
        (response.status === 200 || response.status === 201)
      ) {
        const data = get(response, "data", []);
        setDatatable(data as any);
        setIsLoadTable(false);
      } else {
        MessageStatusError(toNumber(response?.status));
      }
    } finally {
      setIsLoadTable(false);
    }
  };

  const renderFile = (item: any) => {
    return (
      <span
        onClick={() => downloadFile(item)}
        style={{
          color: "blue",
          cursor: "pointer",
          whiteSpace: "normal"
        }}
      >
        {item.tenFile} <br />
      </span>
    );
  };

  /**
   * downloadFile: Tải file
   * @param {object} item
   */
  const downloadFile = (item: any) => {
    fetch(`${item.duongDanFile}`, {
      headers: {
        Authorization: "Bearer ".concat(cookie.load("accessTokenTVDTBDT"))
      }
    }).then((response) => {
      response.blob().then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = item.tenFile;
        a.click();
      });
    });
  };

  /**
   * actionContent: Hành động trên bảng
   * @param {object} item
   * @memberof LoaiTaiLieu
   */
  const actionContent = (item: object) => {
    return (
      <ActionContent
        onDeleteItem={() => deleteItemFunc(item)}
        onEditItem={() => handleRedirect(item)}
      />
    );
  };

  /**
   * deleteItemFunc: Xoá item theo item
   * @param {object} item
   * @memberof LoaiTaiLieu
   */
  const deleteItemFunc = (item: object) => {
    ModalDeleteConfirm(deleteItemAction, item);
  };

  /**
   * deleteItemAction: Xóa item
   * @param {object} item
   * @memberof LoaiTaiLieu
   */
  const deleteItemAction = async (item: any) => {
    setIsLoadTable(true);
    const config = {
      url: `api/tulieufile/delete/${item.id}`,
      apiType: "DELETE",
      value: null,
      method: "DELETE",
      getName: "deleteLoaiTaiLieu"
    };
    const response = await apiCaller(config);
    try {
      if (response?.status === 200 || response?.status === 201) {
        getListData(idTuLieu);
        setIsLoadTable(false);
      } else {
        MessageStatusError(toNumber(response?.status));
        setIsLoadTable(false);
      }
    } catch (error) {
      setIsLoadTable(false);
    }
  };

  const handleRedirect = (item: any) => {
    const listFile = [
      {
        name: item.tenFile,
        url: item.duongDanFile
      }
    ];
    setDuongDanFile(item.duongDanFile);
    setTenFile(item.tenFile);
    setId(item.id);
    setListFile(listFile as any);
    setFieldsValue({
      dinhkem: item
    });
    setFieldsValue({
      dinhkem: {
        listFile: listFile
      }
    });
    setType("edit");
  };

  const customRequest = async (options: any) => {
    const { file, onProgress } = options;
    const fmData = new FormData();
    const url = `${configUrl.API_URL}/api/uploadFile`;
    fmData.append("file", file);

    const headers = {
      Authorization: "Bearer ".concat(cookie.load("accessTokenTVDTBDT"))
    };

    const config = {
      headers,
      onUploadProgress: (event: any) => {
        const percent = Math.floor((event.loaded / event.total) * 100);
        setProgress(percent);
        if (percent === 100) {
          setTimeout(() => setProgress(0), 1000);
        }
        onProgress({ percent: (event.loaded / event.total) * 100 });
      }
    };

    try {
      const response = await axios.post(url, fmData, config);
      if (response.status === 200 || response.status === 201) {
        const listFile = [
          {
            name: response.data.fileName,
            url: response.data.fileDownloadUri
          }
        ];
        setTenFile(response.data.fileName);
        setDuongDanFile(response.data.fileDownloadUri);
        setListFile(listFile as any);
      } else {
        errUploadFile();
      }
    } catch (err) {
      errUploadFile();
      err;
      // Có thể thêm logic xử lý lỗi
    }
  };

  /**
   * onRemoveGiaiTrinh: Xóa file giải trình
   * @param {object} file
   * @memberof EditableCell
   */
  const onRemoveFile = (file: { uid: any }) => {
    const files = (listFile || []).filter(
      (v: { uid: any }) => v.uid !== file.uid
    );
    setListFile(files);
    setDuongDanFile("");
    setTenFile("");
  };

  /**
   * saveAndClose: Lưu và đóng
   * @memberof NhomTaiLieuForm
   */
  const saveData = () => {
    validateFields()
      .then((values) => {
        setLoadingButton(true);
        save(values);
      })
      .catch(() => {
        setLoadingButton(false);
      });
  };

  /**
   * saveData: Lưu dữ liệu
   * @param {object} values
   * @param {boolean} saveQuit
   * @memberof ChucVuForm
   */
  const save = async (values: any) => {
    try {
      let configAPI;
      if (type === "new") {
        const data = {
          listTuLieuFile: [
            {
              idTuLieu: parseInt(idTuLieu, 10),
              moTa: values.dinhkem.moTa,
              tacGia: values.dinhkem.tacGia,
              isSuDung: true,
              duongDanFile: duongDanFile,
              tenFile: tenFile
            }
          ]
        };
        configAPI = {
          url: `api/tulieufile/create`,
          method: "POST",
          data: data,
          apiType: "ADD",
          isShowMessage: true
        };
      } else {
        const data = {
          id,
          idTuLieu: parseInt(idTuLieu, 10),
          moTa: values.dinhkem.moTa,
          tacGia: values.dinhkem.tacGia,
          isSuDung: true,
          duongDanFile: duongDanFile,
          tenFile: tenFile
        };
        configAPI = {
          url: `api/tulieufile/update`,
          method: "PUT",
          data: data,
          apiType: "EDIT",
          isShowMessage: true
        };
      }
      const response = await apiCaller(configAPI as any);
      if (response?.status === 200 || response?.status === 201) {
        if (type === "new") {
          resetFields();
          setListFile([]);
        }
        getListData(idTuLieu);
        setLoadingButton(false);
      } else {
        MessageStatusError(toNumber(response?.status));
        setLoadingButton(false);
      }
    } catch (error) {
      setLoadingButton(false);
    }
  };

  const handleCancel = () => {
    resetFields();
    setType("new");
    setListFile([]);
  };

  const handleChange = (info: any) => {
    setListFile(info.fileList);
  };

  return (
    <>
      <Form form={form} layout="vertical" name="dinhkem-control">
        <Row gutter={24}>
          <Col span={24} md={24}>
            <FormItem
              className="ant-input-group"
              label="Mô tả"
              name={["dinhkem", "moTa"]}
              initialValue={moTa}
            >
              <TextArea rows={3} placeholder="Nhập mô tả" />
            </FormItem>
          </Col>
          <Col span={24} md={12}>
            <FormItem
              className="ant-input-group"
              label="Tên tác giả"
              name={["dinhkem", "tacGia"]}
              rules={[
                {
                  type: "string",
                  required: true,
                  message: messages.ERROR_REQUIRED
                }
              ]}
              initialValue={tacGia}
            >
              <Input className="input-item" placeholder="Nhập tên tác giả" />
            </FormItem>
          </Col>
          <Col span={24} md={12}>
            <FormItem
              className="ant-input-group"
              label="Đính kèm file"
              name={["dinhkem", "listFile"]}
              rules={[
                {
                  required: true,
                  message: messages.ERROR_REQUIRED
                }
              ]}
              initialValue={listFile}
            >
              <Upload
                accept=".jpg,.jpeg,.png,.pdf,.docx,.doc,.mp4"
                beforeUpload={(file) => beforeUploadLimit(35, file)}
                fileList={listFile}
                onChange={handleChange}
                customRequest={customRequest}
                listType="text"
                name="file"
                onRemove={onRemoveFile}
                progress={{
                  strokeColor: {
                    "0%": "#108ee9",
                    "100%": "#87d068"
                  },
                  size: 3,
                  format: (percent) =>
                    progres && `${parseFloat(progres.toFixed(2))}%`
                }}
              >
                <Button className="button-min">
                  <UploadOutlined /> Tải file lên{" "}
                </Button>
              </Upload>
            </FormItem>
          </Col>
        </Row>
        <hr />
        <div style={{ textAlign: "center", padding: 20 }}>
          <Col span={24}>
            <Button
              type="primary"
              htmlType="submit"
              loading={loadingButton}
              onClick={saveData}
              style={{ marginRight: 10 }}
            >
              <SaveOutlined />
              Lưu
            </Button>
            <Button
              onClick={handleCancel}
              icon={<CloseCircleOutlined />}
              variant="outlined"
              color="default"
            >
              Hủy
            </Button>
          </Col>
        </div>
      </Form>
      <div>
        <Table
          rowKey={"id"}
          bordered
          columns={columns}
          className="qti-table-wrapper gx-table-responsive"
          dataSource={datatable}
          rowClassName={(record, index) =>
            index % 2 === 0 ? "qti-table-row-background" : ""
          }
          size="middle"
          pagination={false}
          loading={isLoadTable}
        />
      </div>
    </>
  );
};

export default HinhAnhDinhKem;
